import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import * as Styled from 'shared/dialogs/delete-goal/delete-goal.style';

export type DeleteGoalsMessageProps = {
  count: number;
  isProject?: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};

export const DeleteGoalsMessage: React.FC<DeleteGoalsMessageProps> = ({
  count,
  isProject,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t(
            isProject
              ? 'forms.delete-goals.message.title-project'
              : 'forms.delete-goals.message.title',
            { count },
          )}
        </Typography>
        <Typography variant="body2">
          {t(
            isProject
              ? 'forms.delete-goals.message.description-project'
              : 'forms.delete-goals.message.description',
            { count },
          )}
        </Typography>
        <Typography variant="body2">
          {t(
            isProject
              ? 'forms.delete-goal.message.warning-project'
              : 'forms.delete-goal.message.warning',
          )}
        </Typography>
      </Styled.Header>

      <Styled.Interactions>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.TextPrimary}
          onClick={onCancel}
        >
          {t('forms.delete-goal.message.buttons.cancel.label')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onSubmit}>
          {t('forms.delete-goal.message.buttons.submit.label')}
        </Button>
      </Styled.Interactions>
    </>
  );
};
